var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.79 8.2L12.78 9.21L10.71 7.18L11.72 6.16C11.92 5.95 12.26 5.94 12.5 6.16L13.79 7.41C14 7.62 14.01 7.96 13.79 8.2ZM5.95 11.91L10.12 7.72L12.19 9.8L8.03 14H5.95V11.91ZM10.95 0V2C15.34 2.54 18.45 6.53 17.91 10.92C17.45 14.56 14.59 17.43 10.95 17.88V19.88C16.45 19.28 20.4 14.34 19.8 8.85C19.28 4.19 15.61 0.5 10.95 0ZM8.95 0C6.99 0.18 5.14 0.95 3.62 2.2L5.05 3.74C6.17 2.84 7.52 2.26 8.95 2.06V0.0599999M2.21 3.67C0.95 5.19 0.19 7.04 0 9H2C2.19 7.58 2.75 6.23 3.64 5.1L2.21 3.67ZM0.00999999 11C0.21 12.96 0.98 14.81 2.22 16.33L3.64 14.9C2.76 13.77 2.19 12.42 2.01 11H0.00999999ZM5.01 16.37L3.62 17.74C5.13 19 6.99 19.79 8.95 20V18C7.53 17.82 6.18 17.25 5.05 16.37H5.01Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCam);
export default __webpack_public_path__ + "static/media/cam.3cf373fcd9488093c737aa3454c43e1f.svg";
export { ForwardRef as ReactComponent };